export const projectElementsVisibleKey = "projectElementsVisible";
export const analysisVisibleKey = "analysisVisible";
export const startZoomAreaKey = "startZoomArea";
